'use strict';

$(function() {
    $('.side-menu-button').on('click', function() {
        $('.side-menu-button').toggleClass('menu-open');
        $('.top-menu').toggleClass('menu-open');
    });

    // let $body = $('#top');
    // let markerClzz = 'top-touched';
    // let prevScrollY = window.scrollY;

    // // スクロールイベント監視
    // $(window).scroll(function() {
    //     let y = window.scrollY;
    //     if (prevScrollY > 0 && y <= 0) {
    //         $body.addClass(markerClzz);
    //     } else if (prevScrollY <= 0 && y > 0) {
    //         $body.removeClass(markerClzz);
    //     }
    //     prevScrollY = y;
    // });

    // // 初期状態の設定
    // setTimeout(function() {
    //     let y = window.scrollY;
    //     if (y <= 0) {
    //         $body.addClass(markerClzz);
    //     }
    //     prevScrollY = y;
    // }, 0);
});
